import React from 'react'
import { ApolloProvider } from 'react-apollo'
import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { HttpLink } from 'apollo-link-http'
import { onError } from 'apollo-link-error'
import { ApolloLink, from } from 'apollo-link'
import { navigate } from '@reach/router'
import fetch from 'isomorphic-fetch'

import { useMessagesActions } from '../../state/actions/messages'
import { useAuth } from '../../components/auth/AuthContext'
import { tokenStorage } from '../auth'

export default ({ children }) => {
  const { isAuthenticated, logout } = useAuth()
  const { addMessage } = useMessagesActions()

  const httpAuthMiddleware = new ApolloLink((operation, forward) => {
    const token = tokenStorage.getItem()

    if (isAuthenticated) {
      operation.setContext({
        headers: {
          authorization: `Bearer ${token}`,
        },
      })
    }

    return forward(operation)
  })

  const httpLink = new HttpLink({
    uri: process.env.GATSBY_API_HTTP + '/graphql',
  })

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      for (let err of graphQLErrors) {
        if (err.extensions.code === 'UNAUTHENTICATED') {
          logout()
          addMessage({ type: 'error', text: 'Você não está autenticado!' })
          navigate('/login')
        }

        if (err.extensions.code === 'FORBIDDEN') {
          addMessage({
            type: 'error',
            text: 'Você não tem permissão para realizar essa operação!',
          })
          navigate('/admin')
        }
      }
    }

    if (networkError) {
      if (networkError.statusCode === 401) {
        logout()
        addMessage({ type: 'error', text: 'Você não está autenticado!' })
        navigate('/login')
      }
      // else {
      //   networkError.message = `Erro de conexão com o servidor! Verifique sua conexão com a internet.`
      //   addMessage({ type: 'error', text: networkError.message })
      // }
    }
  })

  const client = new ApolloClient({
    fetch,
    cache: new InMemoryCache(),
    link: from([errorLink, httpAuthMiddleware, httpLink]),
  })

  return <ApolloProvider client={client}>{children}</ApolloProvider>
}
